import type { TextStyleJsonData } from '@/types';
import { convertJsonToData } from '@/utils';

const TITLE_STYLE_JSONS: TextStyleJsonData[] = [
  {
    dropShadow: true,
    dropShadowAlpha: 0.45,
    dropShadowAngle: 1,
    dropShadowBlur: 8,
    dropShadowDistance: 1,
    fill: '#ffffff',
    fontSize: 110,
    stroke: '#c58852'
  },
  {
    dropShadow: true,
    dropShadowAlpha: 0.25,
    dropShadowAngle: 0,
    dropShadowBlur: 7,
    dropShadowColor: '#ffffbc',
    dropShadowDistance: 0,
    fill: ['#fefede', '#fcfcf6'],
    fontSize: 110,
    stroke: '#c58852',
    strokeThickness: 7
  },
  {
    dropShadowAlpha: 0.4,
    dropShadowAngle: 0,
    dropShadowBlur: 4,
    dropShadowColor: '#0b0b09',
    dropShadowDistance: 0,
    fill: '#fcf7d2',
    fontSize: 110,
    stroke: '#fdab57',
    strokeThickness: 7
  },
  {
    dropShadow: true,
    dropShadowAlpha: 0.25,
    dropShadowAngle: 0,
    dropShadowBlur: 6,
    dropShadowDistance: 0,
    fill: '#fdebb2',
    fontSize: 110,
    stroke: '#7c8c21',
    strokeThickness: 10
  },
  {
    dropShadow: true,
    dropShadowAlpha: 0.25,
    dropShadowAngle: 0,
    dropShadowBlur: 4,
    dropShadowDistance: 0,
    fill: ['#fdffec', '#fefbe1'],
    fontSize: 110,
    stroke: '#db934a',
    strokeThickness: 10
  },
  {
    dropShadow: true,
    dropShadowAlpha: 0.25,
    dropShadowAngle: 0,
    dropShadowBlur: 4,
    dropShadowDistance: 0,
    fill: ['#ffe7ad', '#f9ebca', '#e3c784'],
    fontSize: 110,
    stroke: '#ceae65',
    strokeThickness: 10
  }
];

export function getTitleStyles() {
  return TITLE_STYLE_JSONS.map((json) => convertJsonToData(json));
}
